module.exports = __webpack_public_path__ + "img/react.580ffd26.png";